import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { JsonLd } from 'react-schemaorg'
import { type FAQPage } from 'schema-dts'

import { Link } from 'base-ui'

import { useOpenableControls } from '../../../../generic-hooks'
import { PersonalAdviceDialog } from '../../../../personal-advice'
import { useProductPageContext } from '../../productPageContext'

import { jsonLdSchemasFaq } from './jsonLdFaqSchema'
import { ProductFaqsQuestionAndResponse } from './ProductFaqsQuestionAndResponse/ProductFaqsQuestionAndResponse'

const FAQ_SECTION_ID = 'user-questions-section'

export const ProductFaqs: FC = () => {
  const intl = useIntl()

  const { faqs, product } = useProductPageContext()

  const personalAdviceDialogControls = useOpenableControls()

  if (!faqs) {
    return null
  }

  const faqItems = faqs.map(({ faqItem }) => faqItem)

  return (
    <div>
      <h2 className="mb-3.5 text-xl">
        <FormattedMessage
          id="productQuestions.section.headline"
          values={{ productName: product.name }}
        />
      </h2>
      {/* eslint-disable-next-line tailwindcss/no-custom-classname --- needed for JSON LD */}
      <div className="product-questions-list">
        {faqs.map((faq) => (
          <ProductFaqsQuestionAndResponse
            faq={faq}
            key={faq.faqItem.question}
          />
        ))}
      </div>
      <div className="items-baseline tablet:flex">
        <span className="mr-1 font-bold">
          <FormattedMessage id="productQuestions.label.noAnswer" />
        </span>
        <Link
          className="text-dark-primary-max"
          onClick={personalAdviceDialogControls.handleOpen}
          slots={{ root: 'button' }}
          type="button"
        >
          <FormattedMessage id="productQuestions.label.freeConsultancy" />
        </Link>
        <PersonalAdviceDialog
          dialogControls={personalAdviceDialogControls}
          product={product}
        />
      </div>
      <JsonLd<FAQPage>
        item={jsonLdSchemasFaq(
          faqItems,
          intl.formatMessage(
            { id: 'productQuestions.section.headline' },
            { productName: product.name },
          ),
          [`#${FAQ_SECTION_ID} product-questions-list`],
        )}
      />
    </div>
  )
}
